import React from "react";
import {Trans, useTranslation} from "@unibuddy/intl";
import {View, Text, Box, ButtonLink} from "@unibuddy/patron";
import {Redirect, useHistory} from "react-router-dom";
import {rootURL} from "shared/Utils/WhereAmI";
import {AuthPageContainer} from "../components/AuthPageContainer";
import {ThemedLink} from "../../../../components/ThemedLink/ThemedLink";
import {useUniversity} from "../../UniversityProvider/UniversityProvider";
import {IntlNamespaces} from "../../../../translations/types";
import {
    INTL_AGE_REQUIREMENTS,
    INTL_GOT_IT,
    INTL_NOT_QUIET_OLD_ENOUGH,
} from "../../../../translations/verifyAge";

export function MinorPage() {
    const {t} = useTranslation(IntlNamespaces.VERIFY_AGE);
    const {privacyPolicyUrl, features} = useUniversity();
    const history = useHistory();
    const rootUrl = rootURL(location.pathname);
    const ageVerificationR1Enabled = features.get("ageVerificationR1");

    if (!ageVerificationR1Enabled) {
        return (
            <Redirect
                to={{
                    pathname: `${rootUrl}/buddies`,
                    state: {nextPathname: history?.location?.state?.nextPathname},
                }}
            />
        );
    }

    return (
        <AuthPageContainer>
            <View gap="large">
                <Box gap="small" paddingY="xsmall">
                    <Text size="large" weight="bold" align="center">
                        {t(INTL_NOT_QUIET_OLD_ENOUGH.key, INTL_NOT_QUIET_OLD_ENOUGH.defaultValue)}
                    </Text>
                </Box>
                <Text size="medium">
                    <Trans t={t} i18nKey={INTL_AGE_REQUIREMENTS.key}>
                        {
                            "We're sorry, but you do not meet the age requirements to sign up today. Please check the "
                        }
                        <ThemedLink external to={privacyPolicyUrl} target="_blank">
                            {"institution's policy"}
                        </ThemedLink>
                        {" for more details."}
                    </Trans>
                </Text>
                <Text size="medium">
                    <Trans t={t} i18nKey={"needAssistance"}>
                        {"If you need assistance, please contact our "}
                        <ThemedLink external to="https://help.unibuddy.co/" target="_blank">
                            {"support team"}
                        </ThemedLink>
                        {"."}
                    </Trans>
                </Text>
                <ButtonLink color="university" block size="lg" to={`${rootUrl}/buddies`}>
                    {t(INTL_GOT_IT.key, INTL_GOT_IT.defaultValue)}
                </ButtonLink>
            </View>
        </AuthPageContainer>
    );
}
